// 一覧が長くなりすぎたときに、先頭の決まった件数だけを残して残りを件数として伝えるためのユーティリティ。
// 何を切り詰めるのかと上限が何件なのかは呼び出し側の都合で変わるため、ここでは切り詰め方だけを受け持つ。

// 残した内容と、上限を超えて隠した件数。
export type LimitedList<T> = { items: T[]; hiddenCount: number };

// 上限を超えていれば先頭だけを残し、超えた件数を返す。超えていなければそのまま写して隠した件数は0にする。
export function limitedListOf<T>(items: readonly T[], maxCount: number): LimitedList<T> {
  if (items.length > maxCount) {
    return { items: items.slice(0, maxCount), hiddenCount: items.length - maxCount };
  }
  return { items: [...items], hiddenCount: 0 };
}
